import { FileExcelOutlined } from "@ant-design/icons";
import { message } from "antd";
import { useState } from "react";
import ButtonWithPermission from "../ButtonWithPermission/ButtonWithPermission";
import { downloadExcel } from "../../utils/exportExcel";

/**
 * Nút xuất Excel dùng chung cho mọi màn (danh sách, lịch sử, dashboard...).
 * Gọi endpoint export ở BE (trả file theo template chung) rồi tải xuống.
 *
 * @param {string} url        Endpoint export.
 * @param {object} params     Query params (thường là bộ lọc đang áp dụng).
 * @param {string} fileName   Tên file fallback.
 * @param {string} method     'get' | 'post'.
 * @param {object} data       Body khi method=post.
 * @param {string[]} actions  Quyền cần có (rỗng = ai cũng thấy).
 * @param {string} children   Nhãn nút (mặc định "Xuất Excel").
 * @param {function} onSuccess/onError Callback tùy chọn.
 */
export default function ExportExcelButton({
  url,
  params,
  fileName = "export.xlsx",
  method = "get",
  data,
  actions = [],
  children = "Xuất Excel",
  successMessage = "Xuất Excel thành công",
  onSuccess,
  onError,
  ...rest
}) {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await downloadExcel(url, { params, fileName, method, data });
      if (successMessage) message.success(successMessage);
      onSuccess?.();
    } catch (error) {
      message.error(error.message || "Không thể xuất file. Vui lòng thử lại!");
      onError?.(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ButtonWithPermission
      actions={actions}
      icon={<FileExcelOutlined />}
      loading={loading}
      onClick={handleExport}
      {...rest}
    >
      {children}
    </ButtonWithPermission>
  );
}
